import { useAuth0 } from "@auth0/auth0-react";
import { LogOut } from "lucide-react";

import config from "@/config";

import { Button } from "./ui/button";

/**
 * A floating logout button that only appears in development mode
 * when the user is authenticated. Useful for quickly switching accounts
 * during development.
 */
const DevLogoutButton = () => {
  const { isAuthenticated, logout } = useAuth0();

  // Only show in development mode when authenticated
  if (config.env !== "development" || !isAuthenticated) {
    return null;
  }

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Button
      variant="destructive"
      size="sm"
      onClick={handleLogout}
      className="fixed bottom-4 right-4 z-50 shadow-lg opacity-70 hover:opacity-100 transition-opacity"
      title="Dev Logout"
    >
      <LogOut className="h-4 w-4 mr-2" />
      Dev Logout
    </Button>
  );
};

export default DevLogoutButton;
